/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  UnexpectedServiceErrorGuard
} from '../../../share/guards'
import SentimentEmptyResultGuard from './SentimentEmptyResultGuard'

interface SentimentWidgetDataGuardsProps {
  widgetId: number
  children: React.ReactElement
}

const SentimentWidgetDataGuards = ({
  widgetId,
  children
}: SentimentWidgetDataGuardsProps): React.ReactElement => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <TopicLanguageNotSupportedGuard widgetId={widgetId}>
          <SentimentEmptyResultGuard widgetId={widgetId}>{children}</SentimentEmptyResultGuard>
        </TopicLanguageNotSupportedGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default SentimentWidgetDataGuards
